/// \file global.ts
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

const USERWRITENUMBERS=["1"]
const ADVANCEDUSER=["system","segment"]
const SYSTEMUSER=["system"]
const MODELS=[
    "VOLTERRA",
    "EPTO"
  ];
export {USERWRITENUMBERS,ADVANCEDUSER,SYSTEMUSER,MODELS}